// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
import Original from 'lucide-react/dist/esm/icons/panel-left-open.js';

import { paths } from '../generated/panel-left-open';
import { makeBrandedIcon } from '../make-branded';

export default makeBrandedIcon('panel-left-open', Original, paths);
